import { SnackbarProvider } from 'notistack'
import ReactDOM from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import { BrowserRouter } from 'react-router-dom'
import { RecoilRoot } from 'recoil'
import { ThemeProvider } from 'styled-components'

import * as Sentry from '@sentry/react'

import App from '~/App.tsx'
import ErrorBoundary from '~/ErrorBoundary'
import Snackbar from '~/shared/components/snackbar/Snackbar'
import QueryProvider from '~/shared/providers/QueryProvider'
import { GlobalStyle } from '~/shared/styles/global'
import theme from '~/shared/styles/theme'

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled

  tracePropagationTargets: ['localhost', /^https:\/\/api.illustar\.net\/v1/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <ErrorBoundary>
    <HelmetProvider>
      <QueryProvider>
        <ThemeProvider theme={theme}>
          <GlobalStyle />
          <SnackbarProvider
            maxSnack={3}
            autoHideDuration={1500}
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            style={{ padding: 0 }}
            Components={{
              default: Snackbar,
              success: Snackbar,
              error: Snackbar,
              warning: Snackbar,
              info: Snackbar,
            }}
          >
            <BrowserRouter>
              <RecoilRoot>
                <App />
              </RecoilRoot>
            </BrowserRouter>
          </SnackbarProvider>
        </ThemeProvider>
      </QueryProvider>
    </HelmetProvider>
  </ErrorBoundary>,
)
